export default __webpack_public_path__ + "static/media/mariaFilo_desk_banner_5.c54f4230.jpg";